import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import './services/storage';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/:mode" element={<App />} />
        <Route path="/:mode/:tab" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
